import { ReduxService } from './../../../services/redux.service';
import { Subscription } from 'rxjs';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';


@Component({
	selector: 'bb-state-history',
	templateUrl: './bb-state-history.component.html',
	styleUrls: ['./bb-state-history.component.scss'],
})

export class BbStateHistoryComponent implements OnInit, OnDestroy {
	@Input() displayVersions: boolean;

	historySubscription: Subscription;
	stateHistory: any[] = [];
	activeState: any;
	showVersions: false;

	constructor(protected reduxService: ReduxService) {
		this.historySubscription = this.reduxService.historyObs.subscribe((historyData: any) => {
			// timeout to prevent "ExpressionChangedAfterItHasBeenCheckedError"
			setTimeout(() => {
				this.stateHistory = [];
				this.activeState = historyData.present;
				if (historyData && historyData.past) {
					this.stateHistory = [...this.stateHistory, ...historyData.past];
				}
				if (historyData && historyData.present) {
					this.stateHistory = [...this.stateHistory, historyData.present];
				}
				if (historyData && historyData.future) {
					this.stateHistory = [...this.stateHistory, ...historyData.future];
				}
			});
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		if (this.historySubscription) {
			this.historySubscription.unsubscribe();
		}
	}

	action(actionType: string, state?: any) {
		const action: any = {
			type: actionType
		};

		if (state) {
			action.state = state;
		}
		this.reduxService.dispatch(action);
	}
}
